import { extendTheme } from "@chakra-ui/react"

// Один шрифт на всех системах: раньше был системный, и у клиентов на Windows
// (Segoe UI) сайт выглядел иначе, чем у нас на Mac (SF Pro)
const FONT = "\"Manrope\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif"

// Фон страницы почти белый (не чистый #FFF — мягче для глаз). Самый светлый
// серый Chakra, gray.50, для фона уже слишком тёмный — его держит сайдбар
export const PAGE_BG = "#FCFCFD"

export const theme = extendTheme({
  fonts: {
    heading: FONT,
    body: FONT,
  },
  // Стандартные 700 смотрятся слишком жирно в заголовках и шапках таблиц.
  // Шрифт вариативный, поэтому промежуточные значения рисуются как есть
  fontWeights: {
    semibold: 550,
    bold: 600,
    extrabold: 700,
  },
  styles: {
    global: {
      body: {
        bg: PAGE_BG,
      },
      // Рамка фокуса браузера у своих кнопок и ссылок (не Chakra) — серая,
      // а не синяя по умолчанию
      "*:focus-visible": {
        outlineColor: "var(--chakra-colors-gray-300)",
      },
      // Цвета уведомлений react-toastify (тема colored) — из палитры Chakra,
      // как кнопки и бейджи, а не яркие цвета библиотеки по умолчанию
      ":root": {
        "--toastify-color-success": "var(--chakra-colors-green-500)",
        "--toastify-color-error": "var(--chakra-colors-red-500)",
        "--toastify-color-warning": "var(--chakra-colors-orange-400)",
        "--toastify-color-info": "var(--chakra-colors-blue-500)",
        "--toastify-font-family": "var(--chakra-fonts-body)",
      },
    },
  },
  // Кольцо фокуса (кнопки, чекбоксы, ссылки) — серое, в гамме сайдбара,
  // а не синее по умолчанию
  shadows: {
    outline: "0 0 0 3px var(--chakra-colors-gray-200)",
  },
  components: {
    // Поля белые, как таблицы: на сером фоне прозрачное поле выглядело дырой.
    // Рамка в фокусе — серая, а не синяя
    Input: {
      variants: { outline: { field: { bg: "white" } } },
      defaultProps: { focusBorderColor: "gray.300" },
    },
    Select: {
      variants: { outline: { field: { bg: "white" } } },
      defaultProps: { focusBorderColor: "gray.300" },
    },
    Textarea: {
      variants: { outline: { bg: "white" } },
      defaultProps: { focusBorderColor: "gray.300" },
    },
    Table: {
      baseStyle: {
        table: {
          bg: "white",
        },
      },
    },
  },
})
